import React from 'react';
import './faq.scss';
function Model() {
  return (
    <div class="faq">
      <div class="faq-q">
        <span>
          <b>Can I change my billing address?</b>
        </span>
        <p>
      Yes you can, provided your order has not been shipped. Mail us from Customer Service to change your order information. Please note that after your order is shipped you cannot change any details on your order.
        </p>
      </div>
      <div class="faq-q">
        <span>
          <b>Can I change my order information?</b>
        </span>
        <p>
        Mail us from Customer Service to change your order information. Please note that after your order is shipped you cannot change any details on your order.
        </p>
      </div>
      <div class="faq-q">
        <span>
          <b>Can I change the delivery address?</b>
        </span>
        <p>
        Mail us from Customer Service to change your order information. Please note that after your order is shipped you cannot change any details on your order.
        </p>
      </div>
      <div class="faq-q">
        <span>
          <b>Can I customize the product?</b>
        </span>
        <p>
      You can email us a at Customer Service. and your order will be placed as per your choice. Please mention preferable colors, sizes, finish and other details.
        </p>
      </div>
      <div class="faq-q">
        <span>
          <b>Can I get a discount Coupon?</b>
        </span>
        <p>
      If you have received any discount Coupon on your email, you may use the same. You also have access to the Sale Section on the Website. Apart from that, there are no discount Offers currently available.
        </p>
      </div>
      <div class="faq-q">
        <span>
          <b>Can I place an Order over the Phone?</b>
        </span>
        <p>
        Yes, you can place the orders on the phone. We are available from 9.30 AM to 6.00 PM (Mon - Sat).
        </p>
      </div>
      <div class="faq-q">
        <span>
          <b>Can I change my order information?</b>
        </span>
        <p>
        Yes you can change order information
        </p>
      </div>
      <div class="faq-q">
        <span>
          <b>Guidelines For Writing Product Reviews</b>
        </span>
        <ul>
          <li>Product reviews on <b>DAAY-MALL</b> are an optimum way to help fellow customers decide what to buy, and what to avoid. Here are tips to writing product reviews:
          </li>
          <li>
        It's always better to review a product you have used
          </li>
          <li>
        Provide a relevant, unbiased product overview. List all the pros and cons of the product. Make sure you write a review that stays consistent even after years
          </li>
          <li>
        Provide facts to back up your opinion.
          </li>
          <li>
        Do not provide inaccurate information. If you're not sure, research.
          </li>
          <li>
        Be creative but stay on topic.
          </li>
          <li>
        A quick edit and spell check will give you credibility. Also, break reviews into small pointers.
          </li>
        </ul>
      </div>
      <div class="faq-q">
        <span>
          <b>How can I add more products to my order?</b>
        </span>
        <p>
      Mail us at care@farminii.com&amp; to add more products to your order before your order is shipped.
        </p>
      </div>
      <div class="faq-q">
        <span>
          <b>How can I get the discount Coupons?</b>
        </span>
        <p>
      If you are a new customer, you can register on our website and avail discount on your first order with us.
        </p>
      </div>
      <div class="faq-q">
        <span>
          <b>How do I make a Bank Transfer?</b>
        </span>
        <p>
      Bank Transfer is one of the Payment Options available. Below are the details of the Bank where you can make a Transfer.
        </p>
        <ul type="none" id="speicalUl">
          <li><i>Account Name</i> :</li>
          <li><i>Bank Name</i> :</li>
          <li><i>Account No.</i> :</li>
          <li><i>IFSC Code</i> :</li>
          <li><i>Branch</i> :</li>
          <li><i>MICR Code</i> :</li>
        </ul>
      </div>
    </div>

  );
}

export default Model;